import { perseusChargePointRepositoryBuilder } from './PerseusChargePoints'
import { AxiosHttpServiceBuilder } from '@wallbox/http'

export const perseusChargePointRepository = () => perseusChargePointRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
